import _ from 'lodash'

export const checkEmpty = (details, key) => {
  const data = _.get(details, key, '')
  return !_.isEmpty(data) ? data : '-'
}